// theme.mjs — MUI theme for dev_coordinator. Desktop-first, mobile-viable
// (SB-017). Single light theme for the MVP skeleton; makeTheme(mode) is exposed
// so a dark mode / user preference can be layered later without touching callers.
import { createTheme } from '@mui/material/styles';

export function makeTheme(mode = 'light') {
  return createTheme({
    palette: {
      mode,
      primary: { main: '#1565c0' },
      secondary: { main: '#00897b' },
      background:
        mode === 'light'
          ? { default: '#fafafa', paper: '#ffffff' }
          : { default: '#121212', paper: '#1e1e1e' },
    },
    shape: { borderRadius: 8 },
    typography: {
      // System font stack keeps the bundle self-contained (no web-font fetch,
      // which the backend-hosted / same-origin posture would otherwise need).
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        '"PingFang SC"',
        '"Microsoft YaHei"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
    components: {
      MuiButton: { defaultProps: { disableElevation: true } },
    },
  });
}

const theme = makeTheme('light');
export default theme;
